import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
  Collapse,
  TextField,
} from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import UploadCsvDialog from "./uploadCsvDialog";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import TrashIcon from "@mui/icons-material/Delete";
// import {
//   getPlayers,
//   getPlayerEntries,
//   deletePlayer,
// } from "../services/players";
// import { deleteEntry } from "../services/entries";
import TablePagination from "@mui/material/TablePagination";
import { useDispatch, useSelector } from "react-redux";

function Entries() {
  // const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
  const [expandedRows, setExpandedRows] = useState(new Set());
  const [search, setSearch] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const players = useSelector((state) => state.player.players);
  const playerEntries = useSelector((state) => state.player.playerEntries);
  const playersLoading = useSelector((state) => state.player.isLoading);

  useEffect(() => {
    const fetchPlayers = async () => {
      try {
        setLoading(true);
        // TODO : implement getPlayers in features/playerSlice/players.js
        //setTotalCount(response.pagination?.total || 0);
      } catch (error) {
        console.error("Error fetching players:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPlayers();
  }, [page, rowsPerPage, search]);

  const handleDeleteClick = (player) => {
    setSelectedPlayer(player);
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setSelectedPlayer(null);
  };

  const handleConfirmDelete = async () => {
    if (!selectedPlayer) return;
    try {
      //await deletePlayer(selectedPlayer.id);
      //setPlayers((prev) => prev.filter((p) => p.id !== selectedPlayer.id));
    } catch (error) {
      console.error("Error deleting player:", error);
    }
    handleDialogClose();
  };

  const togglePlayerExpansion = async (playerId) => {
    const newExpanded = new Set(expandedRows);

    if (newExpanded.has(playerId)) {
      newExpanded.delete(playerId);
    } else {
      newExpanded.add(playerId);

      // Fetch player entries if not already loaded
      if (!playerEntries[playerId]) {
        try {
          // TODO: implement getPlayerEntries in features/playerSlice/players.js
          // const entries = await getPlayerEntries(playerId);
          // setPlayerEntries((prev) => ({ ...prev, [playerId]: entries }));
        } catch (error) {
          console.error("Error fetching player entries:", error);
        }
      }
    }

    setExpandedRows(newExpanded);
  };

  // ...existing code...

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Players
      </Typography>
      <Typography variant="body1" component="p">
        View and manage players and their entries.
      </Typography>

      <Box sx={{ mt: 2, mb: 2 }}>
        <TextField
          label="Search players"
          variant="outlined"
          size="small"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ mr: 2 }}
          placeholder="Search by name or BSA number"
        />
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            navigate("/entries/add");
          }}
        >
          Add Entry
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => {
            navigate("/");
          }}
          sx={{ ml: 2 }}
        >
          Log
        </Button>
      </Box>
      <Box sx={{ mt: 4, mb: 2 }}>
        <Typography variant="h6">Bulk Upload Entries via CSV</Typography>
        <Button
          variant="contained"
          color="success"
          sx={{ mt: 2 }}
          onClick={() => setUploadDialogOpen(true)}
        >
          Upload CSV
        </Button>
        {/* <UploadCsvDialog
          open={uploadDialogOpen}
          onClose={() => setUploadDialogOpen(false)}
          onSuccess={async () => {
            setUploadDialogOpen(false);
            // Refresh players after upload
            setLoading(true);
            try {
              const response = await getPlayers(page, rowsPerPage, search);
              setPlayers(response.players || []);
              setTotalCount(response.pagination?.total || 0);
            } catch (error) {
              console.error("Error refreshing players:", error);
            } finally {
              setLoading(false);
            }
          }}
        /> */}
      </Box>
      {loading ? (
        <Box
          display="flex"
          flexDirection={"column"}
          justifyContent="center"
          alignItems="center"
          gap={2}
          sx={{ mt: 4, py: 4 }}
        >
          <CircularProgress />
          <Typography variant="caption" sx={{ ml: 2 }}>
            Loading entries...
          </Typography>
        </Box>
      ) : (
        <Paper elevation={3} sx={{ mt: 2 }}>
          <Table sx={{ mt: 2 }}>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                <TableCell />
                <TableCell>Name</TableCell>
                <TableCell>BSA Number</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Total Entries</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {players.map((player) => {
                const isExpanded = expandedRows.has(player.id);
                const entries = playerEntries[player.id] || [];

                return (
                  <>
                    <TableRow key={player.id}>
                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={() => togglePlayerExpansion(player.id)}
                        >
                          {isExpanded ? <ExpandLess /> : <ExpandMore />}
                        </IconButton>
                      </TableCell>
                      <TableCell>
                        {player.firstName} {player.lastName}
                      </TableCell>
                      <TableCell>{player.bsa_number}</TableCell>
                      <TableCell>{player.email}</TableCell>
                      <TableCell>{player.entries?.[0]?.count || 0}</TableCell>
                      <TableCell>
                        <IconButton onClick={() => handleDeleteClick(player)}>
                          <TrashIcon color="error" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                    <TableRow key={`${player.id}-details`}>
                      <TableCell
                        style={{ paddingBottom: 0, paddingTop: 0 }}
                        colSpan={6}
                      >
                        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                          <Box sx={{ margin: 1 }}>
                            <Typography
                              variant="h6"
                              gutterBottom
                              component="div"
                            >
                              Player Entries
                            </Typography>
                            {entries.length === 0 ? (
                              <Typography color="text.secondary">
                                No entries found for this player.
                              </Typography>
                            ) : (
                              <Table size="small">
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Event</TableCell>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Position</TableCell>
                                    <TableCell>Points</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {entries.map((entry) => (
                                    <TableRow key={entry.id}>
                                      <TableCell>{entry.event}</TableCell>
                                      <TableCell>
                                        {moment(entry.event_date).format(
                                          "DD/MM/YYYY"
                                        )}
                                      </TableCell>
                                      <TableCell>
                                        {entry.position?.name}
                                      </TableCell>
                                      <TableCell>
                                        <Typography
                                          variant="body2"
                                          fontWeight={"bold"}
                                        >
                                          {entry.points}
                                        </Typography>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            )}
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </>
                );
              })}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={totalCount}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25, 50]}
          />
        </Paper>
      )}
      {/* Delete Confirmation Dialog */}
      <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this player and all their entries?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            color="error"
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default Entries;
